import ConfirmarExclusao from 'global/guides/Dialog/ConfirmarExclusao'
import { useImplantacaoOutletContext } from 'pages/Implantacao.context'
import { useParams } from 'react-router-dom'
import { saldoHoras } from 'service/api'
import { toast } from 'sonner'

export default function ExcluirImplantacao() {
    const { id } = useParams()
    const { data } = useImplantacaoOutletContext()
    const implantacao = data?.find(item => Number(item.id) === Number(id))

    const { mutateAsync, isLoading } = saldoHoras.mutations.useDelete({
        invalidateQuery: true,
    })

    if (!implantacao) return null

    const handleSubmit = () =>
        mutateAsync(implantacao.id, {
            onSuccess: () => {
                toast.success('Implantação excluída com sucesso')
            },
            onError: err => {
                toast.error(err.message)
            },
        })

    return (
        <ConfirmarExclusao
            permissao={['delete', 'ImplantaçãoDoBancoDeHoras']}
            loading={isLoading}
            onConfirm={handleSubmit}
            title={
                <span>
                    Realmente deseja excluir a implantação de{' '}
                    <strong>{implantacao.horasExtras}</strong> horas extras e{' '}
                    <strong>{implantacao.faltas}</strong> faltas?
                </span>
            }
        />
    )
}
